import React from 'react';
import arrowUpImg from './course-arrow-up.svg';
import arrowDownImg from './course-arrow-down.svg';
import CourseDetail from '../CourseDetail';

const noHeightStyle = {
  minHeight: "0",
};

const courseSummary = (
  courseIdx,
  title,
  description,
  url,
  skills,
  duration,
  isOpen,
  clickFn
) =>
  <div
    className="courseSummary"
    key={`${parseInt(courseIdx, 10)}_${title}`}
    onClick={clickFn.bind(this, courseIdx)}
    style={ isOpen ? null : noHeightStyle }
  >
    <div className="courseSummaryTitle">
      <span className="courseTitle">{title}</span>
      <span className="courseX">
        <img src={isOpen ? arrowDownImg : arrowUpImg} alt=""/>
      </span>
    </div>
    { isOpen ? 
      <CourseDetail courseId={courseIdx} skills={skills} duration={duration} />
      : null
    }
  </div>

class courses extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      openCourse: 0,
    }

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(courseIdx) {
    this.setState({
      openCourse: courseIdx,
    });
  }

  render() {

    const h2Style = {
      display: "inline-block",
      color: "#B3B3B3",
      backgroundColor: "#252525",
      fontSize: "40px",
      marginTop: "0.1em",
      marginBottom: "0",
    };

    const headerContainer = {
      marginTop: '2em'
    };

    return (
      <React.Fragment>
        <div style={headerContainer}>
          <p style={h2Style}>YOU MIGHT BE</p>
          <p style={h2Style}>INTERESTED IN</p><br/>
          <p style={h2Style}>THESE SKILLS:</p>
        </div>
        <div className="courses" >
          {
            this.props.courses.map((course, idx) => {
              return courseSummary(
                idx,
                course.courseTitle,
                course.courseDesc,
                course.courseURL,
                course.skills,
                course.duration,
                (idx === this.state.openCourse),
                this.handleClick
              )
            })
          }
        </div>
        <div>
          <a
            className="beginCourse"
            href={ this.props.courses[this.state.openCourse].courseURL }
          >
            BEGIN >
          </a>
        </div>
      </React.Fragment>
    );
  }
}

export default courses;



// WEBPACK FOOTER //
// ./src/components/Courses/index.js